module.exports = {"Operate24":{"daobanList":[{"title":"1、是否其他建设工程消防验收备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、特殊建设工程消防验收申请表","state":"必要"},{"name":"2、工程竣工验收报告","state":"必要"},{"name":"3、涉及消防的建设工程竣工图纸","state":"必要"},{"name":"4、消防验收不合格意见书及整改情况（如存在需提供）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-24.json
// module id = 1282
// module chunks = 0